import { createContext } from 'react';
import type { CustomControlCode } from '@common/enums';
import type { InputField } from '@common/formEngine/formEngine.types';

export type EditFormSectionInputFieldContextValue<
    Data extends Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined,
    Version extends number,
> = {
    field: InputField<Data, TCustomControlCode, Version>;
    isRequired?: boolean;
    onChange: (value: unknown) => void | Promise<void>;
};

// `any` is necessary because `EditFormSectionInputFieldContextValue` generics have no default values
/* eslint-disable @typescript-eslint/no-explicit-any */
export const EditFormSectionInputFieldContext = createContext<EditFormSectionInputFieldContextValue<
    any,
    any,
    any
> | null>(null);
